import {
  API_AUTOMATE_LOAN_DOCS_GENERATE,
  API_AUTOMATE_LOAN_DOCS_PACKAGES,
  API_AUTOMATE_LOAN_DOCS_RECORD_BY_ID,
  API_AUTOMATE_LOAN_DOCS_RECORDS,
} from 'config'
import Api from 'services/api'

export const getAutomateLoanDocsPackages = () => {
  return Api.get(API_AUTOMATE_LOAN_DOCS_PACKAGES)
}

export const getAutomateLoanDocsRecords = () => {
  return Api.get(API_AUTOMATE_LOAN_DOCS_RECORDS)
}

export const generateAutomateLoanDocs = (packageId?: string, overrideValues?: Record<string, string>) => {
  return Api.post(API_AUTOMATE_LOAN_DOCS_GENERATE, { packageId, overrideValues }, {}, { timeout: 180000 })
}

export const deleteAutomateLoanDocsRecord = (id: number) => {
  return Api.delete(API_AUTOMATE_LOAN_DOCS_RECORD_BY_ID, {}, { id })
}
